import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "shell" }
const _hoisted_2 = { class: "search-container" }
const _hoisted_3 = { class: "search-form-item" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "el-icon-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_input = _resolveComponent("el-input")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_add_button = _resolveComponent("add-button")
  const _component_list_pagination = _resolveComponent("list-pagination")
  const _component_firmware_model = _resolveComponent("firmware-model")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          class: "width400px",
          modelValue: _ctx.listRequestData.param.searchValue,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.listRequestData.param.searchValue = $event))
        }, {
          prepend: _withCtx(() => [
            _createVNode(_component_cus_select, {
              modelValue: _ctx.listRequestData.param.searchKey,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.listRequestData.param.searchKey = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.searchKeyList, (item) => {
                  return (_openBlock(), _createBlock(_component_cus_option, {
                    key: item,
                    value: item.name,
                    label: item.label
                  }, null, 8, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_cus_button, {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateToList++))
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(" " + _toDisplayString(_ctx.$wordList.LogInHtmlSearch), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_add_button, {
        class: "btn-right",
        onClick: _ctx.add
      }, null, 8, ["onClick"])
    ]),
    _createVNode(_component_list_pagination, {
      headers: _ctx.headers,
      requestData: _ctx.listRequestData,
      showDefaultAction: ['edit', 'delete'],
      update: _ctx.updateToList,
      showCheck: false,
      deleteUrl: "deleteversion",
      onEdit: _ctx.edit
    }, {
      LogSlot: _withCtx((data) => [
        _createVNode("span", null, _toDisplayString(data.scope.Log[0]?data.scope.Log[0]:'--'), 1)
      ]),
      _: 1
    }, 8, ["headers", "requestData", "update", "onEdit"]),
    (_ctx.isShowFirmwareModel)
      ? (_openBlock(), _createBlock(_component_firmware_model, {
          key: 0,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowFirmwareModel=false)),
          "init-form": _ctx.initForm,
          "operate-type": _ctx.operateType,
          onSuccess: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateToList++))
        }, null, 8, ["init-form", "operate-type"]))
      : _createCommentVNode("", true)
  ]))
}